function item(title, subtitle = '', state = '', tone = 'neutral') {
  return { title, subtitle, state, tone };
}

function record(type, title) {
  return { type, title };
}

export const site_drawers = {
  'FC-01': {
    section: 'Site - FC-01 - Office',
    title: 'Head office',
    subtitle: 'Gauteng - Pretoria - Monitor: Lerato Botha',
    status: 'Compliant',
    status_class: 'bg-success-subtle text-success-emphasis',
    score: 92,
    score_tone: 'green',
    risk: 'Low',
    risk_tone: 'green',
    open_items: '0',
    occupancy: 'Occupied',
    metadata: [
      { label: 'Site ID', value: 'FC-01' },
      { label: 'Type', value: 'Office' },
      { label: 'Region', value: 'Gauteng - Pretoria' },
      { label: 'Address', value: 'Pretoria CBD - 22 Church Street' },
      { label: 'Responsible manager', value: 'Lerato Botha - HR' }
    ],
    certificates: [
      item('Fire safety certificate', 'Expiry 31 Dec 2026', 'valid', 'success'),
      item('Business / trading licence', 'Expiry 31 Dec 2026', 'valid', 'success'),
      item('Occupancy certificate', 'Permanent', 'valid', 'success')
    ],
    maintenance: [
      item('Emergency evacuation drill', 'Due 18 Jul 2026', 'scheduled', 'warning'),
      item('Electrical CoC', 'Due 30 Sep 2026', 'scheduled', 'warning')
    ],
    utilities: [
      item('Electricity - municipal', 'Connected', 'connected', 'success'),
      item('Water - municipal', 'Connected', 'connected', 'success')
    ],
    security: [
      item('Access control', 'Clear', 'clear', 'success'),
      item('CCTV', 'Operational', 'clear', 'success')
    ],
    incidents: [],
    linked: [
      record('Asset', 'AS-1011 - Dell PowerEdge'),
      record('Contract', 'K-104 - Facilities support'),
      record('Insurance', 'IN-42 - Property cover')
    ],
    team_notes: [
      item('Valid fire & occupancy certificates', '', 'ok', 'success'),
      item('Operating / facility licence', '', 'ok', 'success'),
      item('Inspection & drill records', '', 'ok', 'success'),
      item('Maintenance log', '', 'ok', 'success'),
      item('Utilities & waste manifests', '', 'ok', 'success')
    ],
    recommended_action: 'Keep the scheduled evacuation drill and electrical CoC on the next monthly facilities check-in.'
  },
  'FC-02': {
    section: 'Site - FC-02 - Clinic',
    title: 'Soweto community clinic',
    subtitle: 'Gauteng - Soweto - Site sponsor: Aisha Naidoo',
    status: 'At risk',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    score: 58,
    score_tone: 'red',
    risk: 'Critical',
    risk_tone: 'red',
    open_items: '4',
    occupancy: 'Occupied',
    metadata: [
      { label: 'Site ID', value: 'FC-02' },
      { label: 'Type', value: 'Clinic' },
      { label: 'Region', value: 'Gauteng - Soweto' },
      { label: 'Address', value: 'Soweto - Zone 4' },
      { label: 'Responsible manager', value: 'Aisha Naidoo - Operations' }
    ],
    certificates: [
      item('Fire safety certificate', 'Expiry 02 Apr 2026', 'expired', 'danger'),
      item('Health facility licence', 'Expiry 30 Sep 2026', 'renewal due', 'warning'),
      item('Occupancy certificate', 'Valid', 'valid', 'success')
    ],
    maintenance: [
      item('Fire extinguisher inspection', 'Overdue', 'overdue', 'danger'),
      item('Infection-control audit', 'Due 20 Jul 2026', 'due', 'warning')
    ],
    utilities: [
      item('Electricity - municipal', 'Connected', 'connected', 'success'),
      item('Medical waste removal', 'Connected', 'connected', 'success')
    ],
    security: [
      item('Access control', 'Action needed', 'action needed', 'warning'),
      item('Guarding', 'Night-only', 'weak', 'warning')
    ],
    incidents: [
      item('Patient slip in waiting area', 'INC-18 - closed', 'closed', 'success')
    ],
    linked: [
      record('Asset', 'AS-0457 - Fire suppression'),
      record('Incident', 'INC-18 - Patient slip'),
      record('Insurance', 'IN-31 - Clinic cover')
    ],
    team_notes: [
      item('Valid fire & occupancy certificates', '', 'gap', 'danger'),
      item('Operating / facility licence', '', 'renewal', 'warning'),
      item('Inspection & drill records', '', 'missing', 'danger'),
      item('Maintenance log', '', 'missing', 'danger'),
      item('Utilities & waste manifests', '', 'ok', 'success')
    ],
    recommended_action: 'Urgently book the fire-extinguisher inspection and replace the expired fire certificate before the next clinic operating review.'
  },
  'FC-03': {
    section: 'Site - FC-03 - Office',
    title: 'Cape Town regional office',
    subtitle: 'Western Cape - Regional Manager: Nomsa Dube',
    status: 'Monitoring',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    score: 88,
    score_tone: 'green',
    risk: 'Low',
    risk_tone: 'green',
    open_items: '1',
    occupancy: 'Live',
    metadata: [
      { label: 'Site ID', value: 'FC-03' },
      { label: 'Type', value: 'Office' },
      { label: 'Region', value: 'Western Cape' },
      { label: 'Address', value: 'Cape Town Foreshore' },
      { label: 'Responsible manager', value: 'Nomsa Dube - Regional Manager' }
    ],
    certificates: [
      item('Fire safety certificate', 'Expiry 31 Aug 2026', 'valid', 'success'),
      item('Business licence', 'Expiry 31 Mar 2027', 'valid', 'success')
    ],
    maintenance: [
      item('Emergency evacuation drill', 'Due overdue', 'overdue', 'danger'),
      item('Air-conditioning service', 'Due 14 Aug 2026', 'scheduled', 'warning')
    ],
    utilities: [
      item('Electricity - municipal', 'Connected', 'connected', 'success')
    ],
    security: [
      item('Access control', 'Alert', 'alert', 'warning'),
      item('Guarding contract', 'Active', 'active', 'success')
    ],
    incidents: [],
    linked: [
      record('Asset', 'AS-2210 - Toyota Hilux'),
      record('Contract', 'K-101 - Regional office support')
    ],
    team_notes: [
      item('Valid fire & occupancy certificates', '', 'ok', 'success'),
      item('Operating / facility licence', '', 'ok', 'success'),
      item('Inspection & drill records', '', 'gap', 'warning'),
      item('Maintenance log', '', 'ok', 'success'),
      item('Utilities & waste manifests', '', 'ok', 'success')
    ],
    recommended_action: 'Close the overdue evacuation drill and attach the signed drill report to keep the regional office out of escalation.'
  },
  'FC-04': {
    section: 'Site - FC-04 - Warehouse',
    title: 'Central warehouse',
    subtitle: 'Gauteng - Midrand - Warehouse Manager: Kabelo Tau',
    status: 'Monitoring',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    score: 79,
    score_tone: 'amber',
    risk: 'Medium',
    risk_tone: 'amber',
    open_items: '4',
    occupancy: 'Occupied',
    metadata: [
      { label: 'Site ID', value: 'FC-04' },
      { label: 'Type', value: 'Warehouse' },
      { label: 'Region', value: 'Gauteng - Midrand' },
      { label: 'Address', value: 'Midrand - Distribution park' },
      { label: 'Responsible manager', value: 'Kabelo Tau - Warehouse Manager' }
    ],
    certificates: [
      item('Hazardous waste permit', 'Expiry 15 Jul 2026', 'renewal due', 'warning'),
      item('Forklift & racking inspection', 'Due 12 Jul 2026', 'due', 'warning'),
      item('Slip & fall corrective verification', 'Open', 'action needed', 'warning')
    ],
    maintenance: [
      item('Loading-dock repair', 'Due 22 Jul 2026', 'scheduled', 'warning')
    ],
    utilities: [
      item('Electricity - municipal', 'Connected', 'connected', 'success'),
      item('Hazardous waste removal', 'Connected', 'connected', 'success')
    ],
    security: [
      item('Access control', 'Active', 'active', 'success'),
      item('CCTV', 'Perimeter coverage', 'active', 'success')
    ],
    incidents: [
      item('Slip & fall - warehouse floor (HS-01)', 'Open corrective action', 'open', 'warning')
    ],
    linked: [
      record('Asset', 'AS-3309 - Standby generator'),
      record('Incident', 'INC-19 - Slip and fall'),
      record('Insurance', 'IN-52 - Load-loss policy')
    ],
    team_notes: [
      item('Valid fire & occupancy certificates', '', 'ok', 'success'),
      item('Operating / facility licence', '', 'ok', 'success'),
      item('Inspection & drill records', '', 'gap', 'warning'),
      item('Maintenance log', '', 'ok', 'success'),
      item('Utilities & waste manifests', '', 'ok', 'success')
    ],
    recommended_action: 'Attach the slip-and-fall corrective closure proof and renew the hazardous-waste permit before the next warehouse review.'
  },
  'FC-05': {
    section: 'Site - FC-05 - Training site',
    title: 'Durban training centre',
    subtitle: 'KwaZulu-Natal - Durban - Centre lead: Lerato Botha',
    status: 'Compliant',
    status_class: 'bg-success-subtle text-success-emphasis',
    score: 84,
    score_tone: 'green',
    risk: 'Low',
    risk_tone: 'green',
    open_items: '0',
    occupancy: 'Live',
    metadata: [
      { label: 'Site ID', value: 'FC-05' },
      { label: 'Type', value: 'Training site' },
      { label: 'Region', value: 'KwaZulu-Natal - Durban' },
      { label: 'Address', value: 'Durban - Greyville' },
      { label: 'Responsible manager', value: 'Lerato Botha - Centre Lead' }
    ],
    certificates: [
      item('Fire safety certificate', 'Expiry 28 Feb 2027', 'valid', 'success'),
      item('Accreditation certificate', 'Expiry 31 Oct 2026', 'valid', 'success')
    ],
    maintenance: [
      item('Venue safety check', 'Due 30 Jun 2026', 'scheduled', 'warning'),
      item('Projector & AV service', 'Due 14 Aug 2026', 'scheduled', 'warning')
    ],
    utilities: [
      item('Electricity - municipal', 'Connected', 'connected', 'success'),
      item('Access control', 'Active', 'active', 'success')
    ],
    security: [
      item('Access control', 'Active', 'active', 'success')
    ],
    incidents: [],
    linked: [
      record('Asset', 'AS-5120 - Laptop fleet'),
      record('Certificate', 'CR-11 - Accreditation')
    ],
    team_notes: [
      item('Valid fire & occupancy certificates', '', 'ok', 'success'),
      item('Operating / facility licence', '', 'ok', 'success'),
      item('Inspection & drill records', '', 'ok', 'success'),
      item('Maintenance log', '', 'ok', 'success'),
      item('Utilities & waste manifests', '', 'ok', 'success')
    ],
    recommended_action: 'Keep the venue safety check on schedule and upload the next AV service certificate once complete.'
  }
};
